import { ClassifiedUsedEquipmentBlock } from '../../rest/types/Classified'

export function BlockUsedEquipmentTransformer({
  block,
  t,
}: {
  block: ClassifiedUsedEquipmentBlock
  t: any
}) {
  console.log('block', block)
  return {
    adsTypes: {
      items: [
        {
          title: t('ads_types_used_equipment_title'),
          text: t(`ads_types_used_equipment_type_${block?.type}`),
        },
      ],
    },
  }
}
